import React from 'react';

export interface ShadowingProfileIconProps {
  size?: number;
  className?: string;
}

export const ShadowingProfileIcon: React.FC<ShadowingProfileIconProps> = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Head profile facing right with open mouth */}
    <path d="M12 4a3.5 3.5 0 0 0-3.5 3.5v1.2c0 .8-.4 1.5-1 2l-.8.6c-.5.4-.7 1-.7 1.7 0 1.2 1 2 2.2 2h2.3" />
    <path d="M5 20v-1a4 4 0 0 1 4-4h2.5" />
    {/* Open mouth arc */}
    <path d="M11 11.5c.6.4 1.2.5 1.8.2" />
    {/* Sound waves emitting from mouth */}
    <path d="M16 10a3 3 0 0 1 0 4" />
    <path d="M19 8a6 6 0 0 1 0 8" />
  </svg>
);

export default ShadowingProfileIcon;
